// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var WarningController = function ($scope, $modalInstance, warning) {
    $scope.warning = warning;
    $scope.close = function () {
        $modalInstance.close();
    };
};
WarningController.$inject = ["$scope", "$uibModalInstance", "warning"];
